  (function() {
    var REDIRECT_PATH = "/account";
    var logoutBtn = document.querySelector('a[href^="/account/logout"]');
    if(logoutBtn) {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => window.location.href = REDIRECT_PATH);
      })
    }
  })();
  if(localStorage.getItem("reset")){
    $(".overlay").addClass("overlay-opens-password");
      $("body").addClass("drawer-opens-password");
      $(".reset_password_success").addClass("view-address-model");
    localStorage.removeItem("reset");
  }

  $("body").on("click", ".site-nav__link", function(){
    
  window.dataLayer.push({
    'event': 'main nav-',
    'eventAction': 'main nav',
    'eventLabel': $(this).attr("data-title")
  });
  
});
$("body").on("click", ".menu_heading a, .mega_mega-site-nav__item_link, .menga_menu_link", function(){
  
  window.dataLayer.push({
    'event': 'main nav-',
    'eventAction': 'sub nav',
    'eventLabel': $(this).text()
  });
  
  
});
$("body").on("click", ".footer__menu li a", function(){
  
  window.dataLayer.push({
    'event': 'footer nav-',
    'eventAction': 'footer nav',
    'eventLabel': $(this).text()
  });
  
  
});